import Vue from "vue";
import NavMixin from "./mixins/nav";

/**
 * SNIPPETS & POLYFILLS
 */
require("es6-promise").polyfill();
require("picturefill");
require("intersection-observer");
require("./polyfill");
require("./snippets/tooltips");
require("./snippets/video");


/**
 * VUE
 */
require("./vue-use");
require("./vue-components");

const app = new Vue({
	el: '#app',
	mixins: [NavMixin],
})
